import { createSlice } from "@reduxjs/toolkit";

export const QuestionDetailSlice = createSlice({
    name: "questionDetail",
    initialState: {
        questionDetail: null,
    },
    reducers: {
        setquestiondetail: (state, action) => {
            state.questionDetail = action.payload;
        },
        clearquestiondetail: (state, action) => {
            state.questionDetail = null;
        }
    }
})

export const { setquestiondetail, clearquestiondetail } = QuestionDetailSlice.actions;

export default QuestionDetailSlice.reducer;